export default "__VITE_PUBLIC_ASSET__ba671388__"